module.exports = __webpack_public_path__ + "img/aghk-bus-disabled.8f484618.svg";